module.exports = __webpack_public_path__ + "img/symbol_0.c9eb58ca.png";